import antdEnUS from "antd/es/locale/en_US";
import antdArEG from "antd/es/locale/ar_EG";
import antdZhCn from "antd/es/locale/zh_CN";
import antdFrFR from "antd/es/locale/fr_FR";
import antdJaJP from "antd/es/locale/ja_JP";

import en from "./locales/en_US.json";
import ar from "./locales/ar_SA.json";
import zh from "./locales/zh_CN.json";
import fr from "./locales/fr_FR.json";
import ja from "./locales/ja_JP.json";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { THEME_CONFIG } from "configs/AppConfig";

export const resources = {
  en: {
    translation: en,
    antd: antdEnUS,
  },
  ar: {
    translation: ar,
    antd: antdArEG,
  },
  zh: {
    translation: zh,
    antd: antdZhCn,
  },
  fr: {
    translation: fr,
    antd: antdFrFR,
  },
  ja: {
    translation: ja,
    antd: antdJaJP,
  },
};

// Get saved language or use default
const savedLanguage = localStorage.getItem("selectedLanguage");
// const initialLanguage = savedLanguage || THEME_CONFIG.locale;
const initialLanguage = THEME_CONFIG.locale;

i18n.use(initReactI18next).init({
  resources,
  fallbackLng: THEME_CONFIG.locale,
  lng: initialLanguage,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
